import { render, staticRenderFns } from "./FAQAuctionsComponent.vue?vue&type=template&id=7a0095e6&scoped=true&"
import script from "./FAQAuctionsComponent.vue?vue&type=script&lang=ts&"
export * from "./FAQAuctionsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FAQAuctionsComponent.vue?vue&type=style&index=0&id=7a0095e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0095e6",
  null
  
)

export default component.exports